import { A11yModule } from "@angular/cdk/a11y";
import { CommonModule, TitleCasePipe } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    model
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxComponent } from '../../../@core/components/ui/checkbox';
import { DatepickerComponent } from '../../../@core/components/ui/datepicker';
import { DatePickerConfig } from '../../../@core/components/ui/datepicker/datepicker.model';
import { DialogComponent } from '../../../@core/components/ui/dialog/dialog.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { Popover, PopoverModule } from 'primeng/popover';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonComponent } from "../../../@core/components/ui/button/button.component";
import { SelectComponent, SelectOption, SelectConfig } from "../../../@core/components/ui/select";
import { IMilestone, IUser } from '../../../@core/models/model';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { ToastService } from '../../../@core/services/toast.service';
import { DialogService } from '../../../@core/services/dialog.service';
import { TextCasePipe } from "../../../@shared/pipes/textCase.pipe";
@Component({
    selector: 'app-milestones',
    imports: [
        CommonModule,
        FormsModule,
        DatepickerComponent,
        CheckboxComponent,
        ButtonComponent,
        PopoverModule,
        DialogComponent,
        A11yModule,
        SelectModule,
        InputNumberModule,
        RadioButtonModule,
        TooltipModule,
        TitleCasePipe,
        SelectComponent,
        TextCasePipe
    ],
    standalone: true,
    templateUrl: './milestones.component.html',
    styleUrl: './milestones.component.scss'
})
export class MilestonesComponent implements OnInit {
    @Input() milestones: IMilestone[] = [];
    @Input() showActions: boolean = true;
    @Input() maxMilestoneDueDate?: Date | string;
    @Input() permissions: {
        canView: boolean,
        canEdit: boolean,
        canComment: boolean,
        restricted: boolean
    } = {
            canView: true,
            canEdit: true,
            canComment: true,
            restricted: false
        };
    @Output() save = new EventEmitter<{
        edited: Partial<IMilestone>[];
        deleted: string[];
    }>();
    @Input() showHeader = true;

    @Output() cancel = new EventEmitter<void>();
    @Output() milestonesChange = new EventEmitter<Partial<IMilestone>[]>();

    editableMilestones = model<Array<Partial<IMilestone>>>([]);
    deletedMilestoneIds = model<string[]>([]);

    @ViewChild('customNotificationPanel') customPanel!: Popover;
    quickOptionsDate: Date = new Date();    // used for quick options date
    tempCustomDate!: Date;
    tempCustomTime!: Date;
    minDateForDueDate: Date = new Date();
    maxDateForNotify: Date = new Date();

    currentUser: IUser | null | undefined = null;



    currentIndex = -1;
    showCustomDialog: boolean = false;
    selectedMilestone: Partial<IMilestone> | null = null;

    quickOptions = [
        { label: '2 days', value: 2 },
        { label: '5 days', value: 5 },
        { label: '2 weeks', value: 14 },
        { label: '3 weeks', value: 21 },
        { label: '6 months', value: 180 },
        { label: '1 year', value: 365 }
    ];

    selectedQuickOption: number | null = null;

    repeatOptions: SelectOption[] = [
        { label: 'None (one-time reminder)', value: 'none' },
        { label: 'Daily until due', value: 'daily' },
        { label: 'Weekly until due', value: 'weekly' },
        { label: 'Weekdays only until due', value: 'weekdays' },
        { label: 'Monthly until due', value: 'monthly' },
        { label: 'Yearly until due', value: 'yearly' },
        { label: 'Custom', value: 'custom' },
    ];

    repeatConfig: SelectConfig = {
        placeholder: 'Select a Repeat',
        searchable: false,
        clearable: true,
        styleClass: 'w-3/5 px-1 py-0.5 text-xs rounded-lg border shadow-sm hover:bg-gray-50 cursor-pointer',
        appendTo: 'body'
    };

    selectedRepeatOption: string = 'none';
    repeatFrequency: number = 1;
    repeatUnit: string = 'week';
    repeatUnits: SelectOption[] = [
        { label: 'day', value: 'day' },
        { label: 'week', value: 'week' },
        { label: 'month', value: 'month' },
        { label: 'year', value: 'year' }
    ];

    repeatUnitsConfig: SelectConfig = {
        placeholder: 'Select unit',
        searchable: false,
        clearable: false,
        styleClass: 'text-xs border shadow-sm hover:bg-gray-50 cursor-pointer',
        style: { 'min-width': '100px' },
        appendTo: 'body'
    };

    weekDays = [
        { label: 'S', value: 'SUN', selected: false },
        { label: 'M', value: 'MON', selected: false },
        { label: 'T', value: 'TUE', selected: false },
        { label: 'W', value: 'WED', selected: false },
        { label: 'T', value: 'THU', selected: false },
        { label: 'F', value: 'FRI', selected: false },
        { label: 'S', value: 'SAT', selected: false }
    ];

    endOptions = [
        { label: 'Never', value: 'never' },
        { label: 'On', value: 'on' },
        { label: 'After', value: 'after' }
    ];
    selectedEndOption: string = 'never';
    endDate: Date | null = null;
    occurrences: number = 1;

    selectedNotificationChannels: { email: boolean, inApp: boolean } = { email: true, inApp: true };

    customDateReminderConfig: DatePickerConfig = {
        showIcon: true,
        dateFormat: 'dd/mm/yy',
        appendTo: 'body',
        keepInvalid: true,
        placeholder: 'Pick a reminder date'
    };

    get maxMilestoneDueDateAsDate(): Date | undefined {
        if (!this.maxMilestoneDueDate) return undefined;
        return this.maxMilestoneDueDate instanceof Date ? this.maxMilestoneDueDate : new Date(this.maxMilestoneDueDate);
    }

    constructor(private toast: ToastService,
        private authService: AuthenticationService, private dialogService: DialogService) {
        this.authService.currentUser.subscribe(res => {
            this.currentUser = res;
        });
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.minDateForDueDate = today;
    }

    toggleWeekDay(day: any) {
        day.selected = !day.selected;
    }

    selectQuickOption(value: number) {
        this.selectedQuickOption = this.selectedQuickOption === value ? null : value;
        if (this.selectedQuickOption) {
            this.tempCustomDate = this.selectedMilestone?.date ? new Date(this.selectedMilestone?.date) : new Date();
            const selectedDate = new Date(this.quickOptionsDate);
            selectedDate.setDate(selectedDate.getDate() + value);
            this.quickOptionsDate = selectedDate;
            this.pickCustomDateReminderToggle = false;
        }
    }




    ngOnInit() {
        this.editableMilestones.set(this.milestones.map(m => ({
            ...m,
            date: m.date ? new Date(m.date) : new Date(new Date().setHours(23, 59, 59, 999)),
            reminder: m.reminder
        })));
    }

    addMilestone() {
        const current = this.editableMilestones();
        this.editableMilestones.set([...current, {
            name: `Milestone ${current.length + 1}`,
            date: new Date()
        }]);
        this.emitMilestonesChange();
    }

    deleteMilestone(i: number) {
        const current = this.editableMilestones();
        const id = current[i]._id;
        if (id) {
            const deletedIds = this.deletedMilestoneIds();
            this.deletedMilestoneIds.set([...deletedIds, id]);
        }
        const updated = [...current];
        updated.splice(i, 1);
        this.editableMilestones.set(updated);
        this.emitMilestonesChange();
    }

    onSave() {
        this.save.emit({
            edited: this.editableMilestones(),
            deleted: this.deletedMilestoneIds()
        });
    }

    onCancel() {
        this.cancel.emit();
    }

    onDueDateChange(i: number) {
        this.emitMilestonesChange();
    }

    openCustomNotificationPanel(event: Event, i: number) {


        this.currentIndex = i;
        const m = this.editableMilestones()[i];
        this.selectedMilestone = m;
        if (!this.selectedMilestone.date) {
            this.toast.error('Please set a Due Date for the milestone');
            return;
        }
        this.customDateReminderConfig = {
            ...this.customDateReminderConfig,
            minDate: this.minDateForDueDate,
            maxDate: this.selectedMilestone?.date
        };
        if (m.reminder) {
            this.tempCustomDate = new Date(m.reminder.date);
            this.tempCustomTime = new Date(m.reminder.time);

            this.selectedQuickOption = m.reminder.quickOption || null;

            if (m.reminder.repeat) {
                const repeat = m.reminder.repeat;
                this.selectedRepeatOption = repeat.option || 'none';
                if (repeat.option === 'custom') {
                    this.repeatFrequency = repeat.frequency || 1;
                    this.repeatUnit = repeat.unit || 'week';
                    if (repeat.weekDays) {
                        this.weekDays.forEach(day => {
                            day.selected = repeat.weekDays!.includes(day.value as any);
                        });
                    }
                }
            }

            if (m.reminder.end) {
                this.selectedEndOption = m.reminder.end.value;
                this.endDate = m.reminder.end.date ? new Date(m.reminder.end.date) : null;
                this.occurrences = m.reminder.end.occurrences || 1;
            }

            if (m.reminder.deliveryChannels) {
                this.selectedNotificationChannels = {
                    email: m.reminder.deliveryChannels.email,
                    inApp: m.reminder.deliveryChannels.inApp
                };
            }
        } else {
            const base = m.date ? new Date(m.date as Date) : new Date();
            this.tempCustomDate = new Date(base);
            this.tempCustomTime = new Date(base);
            this.tempCustomTime.setHours(9, 0, 0, 0);
            this.selectedQuickOption = null;
            this.selectedRepeatOption = 'none';
            this.selectedEndOption = 'never';
            this.endDate = null;
            this.occurrences = 1;
            this.weekDays.forEach(day => day.selected = false);
            this.selectedNotificationChannels = { email: true, inApp: true };
        }

        this.showCustomDialog = true;
    }

    applyCustomNotification() {
        const current = this.editableMilestones();
        const m = current[this.currentIndex];
        const dt = new Date(this.tempCustomDate);
        dt.setHours(this.tempCustomTime.getHours(), this.tempCustomTime.getMinutes(), 0, 0);

        const updatedMilestone = {
            ...m,
            reminder: {
                date: dt,
                time: this.tempCustomTime,
                quickOption: this.selectedQuickOption,
                repeat: {
                    enabled: !!this.selectedRepeatOption && this.selectedRepeatOption !== 'none',
                    option: this.selectedRepeatOption || 'none',
                    unit: this.selectedRepeatOption === 'custom' ? this.repeatUnit : undefined,
                    weekDays: this.selectedRepeatOption === 'custom' && this.repeatUnit === 'week'
                        ? this.weekDays.filter(d => d.selected).map(d => d.value as any)
                        : undefined,
                },
                end: {
                    value: this.selectedEndOption,
                    date: this.selectedEndOption === 'on' ? this.endDate : undefined,
                    occurrences: this.selectedEndOption === 'after' ? this.occurrences : undefined
                },
                deliveryChannels: {
                    email: this.selectedNotificationChannels.email,
                    inApp: this.selectedNotificationChannels.inApp
                }
            } as any
        };

        const updated = [...current];
        updated[this.currentIndex] = updatedMilestone;
        this.editableMilestones.set(updated);

        this.showCustomDialog = false;
        this.selectedMilestone = null;
        this.emitMilestonesChange();
    }

    removeCustomNotification(i: number) {
        const current = this.editableMilestones();
        const updated = [...current];
        updated[i] = { ...updated[i], reminder: undefined };
        this.editableMilestones.set(updated);
        this.currentIndex = -1;
        this.emitMilestonesChange();
    }

    emitMilestonesChange() {
        this.milestonesChange.emit(this.editableMilestones());
    }
    pickCustomDateReminderToggle = false;
    pickCustomDateForReminder() {
        this.pickCustomDateReminderToggle = !this.pickCustomDateReminderToggle;
    }

    onCustomDateChange() {
        this.selectedQuickOption = null;
    }

    onToggleNotificationChannels() {
        this.selectedNotificationChannels = {
            email: this.selectedNotificationChannels.email,
            inApp: this.selectedNotificationChannels.inApp
        };
    }

    isReminderDateValid(): boolean {
        if (!this.tempCustomDate || !this.tempCustomTime) {
            return false;
        }

        // Combine date and time
        const reminderDateTime = new Date(this.tempCustomDate);
        reminderDateTime.setHours(
            this.tempCustomTime.getHours(),
            this.tempCustomTime.getMinutes(),
            0,
            0
        );
        const now = new Date();

        // Check if the reminder date is in the future
        if (reminderDateTime <= now) {
            return false;
        }
        const maxDateAllowed = this.maxMilestoneDueDateAsDate ? new Date(this.maxMilestoneDueDateAsDate) : new Date();
        maxDateAllowed.setHours(23, 59, 59, 999);
        // Check if the reminder date is less than or equal to the project Due Date
        if (this.maxMilestoneDueDateAsDate && reminderDateTime > maxDateAllowed) {
            return false;
        }

        // check if one of the notification channels is selected
        if (!this.selectedNotificationChannels.email && !this.selectedNotificationChannels.inApp) {
            return false;
        }

        return true;
    }

    isReminderDateAfterMilestone(): boolean {
        if (!this.tempCustomDate || !this.selectedMilestone?.date) {
            return false;
        }
        const reminderDate = new Date(this.tempCustomDate);
        reminderDate.setHours(0, 0, 0, 0);
        const milestoneDate = new Date(this.selectedMilestone.date);
        milestoneDate.setHours(0, 0, 0, 0);
        return reminderDate > milestoneDate;
    }

    removeReminder() {
        this.dialogService.confirm({
            title: 'Are you sure?',
            description: 'Are you sure you want to remove the reminder?',
            confirmText: 'Remove',
            cancelText: 'Cancel',
            confirmVariant: 'destructive',
        }).subscribe(confirmed => {
            if (confirmed) {
                const current = this.editableMilestones();
                const updated = [...current];
                updated[this.currentIndex] = { ...updated[this.currentIndex], reminder: undefined };
                this.editableMilestones.set(updated);
                this.currentIndex = -1;
                this.emitMilestonesChange();
                this.showCustomDialog = false;
            }
        });
    }

    getCustomizeReminderHeader(): string {
        return `Set reminder`;
    }

    getCustomizeReminderLabel(): string {
        return this.selectedMilestone?.reminder ? 'Customize' : 'Set Reminder';
    }
}
